import { render, staticRenderFns } from "./ProfilesTable.vue?vue&type=template&id=9370b852&scoped=true"
import script from "./ProfilesTable.vue?vue&type=script&lang=js"
export * from "./ProfilesTable.vue?vue&type=script&lang=js"
import style0 from "./ProfilesTable.vue?vue&type=style&index=0&id=9370b852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9370b852",
  null
  
)

export default component.exports